<template>
  <KTCodePreview v-bind:title="'Danh sách Hình ảnh'">
    <!-- <b-container> -->
    <template v-slot:toolbar>
      <b-row>
        <b-button variant="primary" to="/images/upload">
          <i class="fa fa-cloud-upload-alt mr-2"></i>
          Tải lên
        </b-button>
      </b-row>
    </template>

    <template v-slot:preview>
      <b-row>
        <b-col cols="12">
          <b-card class="border">
            <b-card-title>
              <b-row align-v="center">
                <b-col cols="12" md="6" lg="4">
                  <b-input-group>
                    <b-form-input
                      v-model="search"
                      placeholder="Tìm kiếm hình ảnh"
                      trim
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        variant="outline-secondary"
                        @click="search = ''"
                      >
                        <i class="fa fa-times"></i>
                      </b-button>
                      <b-button variant="outline-secondary">
                        <i class="fa fa-search"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-col>

                <b-col cols="6" md="3" lg="2" class="mt-3 mt-md-0">
                  <b-form-select
                    v-model="statusFilter"
                    :options="statusOptions"
                    size="sm"
                  ></b-form-select>
                </b-col>

                <b-col cols="6" md="3" lg="2" class="mt-3 mt-md-0">
                  <b-form-select
                    v-model="sortBy"
                    :options="sortOptions"
                    size="sm"
                  ></b-form-select>
                </b-col>
              </b-row>
            </b-card-title>

            <b-card-text>
              <!-- <loading-overlay :active="isLoading" :is-full-page="false">
              Loading images...
            </loading-overlay> -->

              <image-grid
                :images="filteredImages"
                @delete="refreshImages"
              ></image-grid>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </template>
    <!-- </b-container> -->
  </KTCodePreview>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ImageGrid from '@/view/components/images/ImageGrid';
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
// import LoadingOverlay from '@/view/components/common/LoadingOverlay';

export default {
  name: 'ImageList',
  components: {
    ImageGrid,
    KTCodePreview,
    // LoadingOverlay,
  },
  data() {
    return {
      search: '',
      statusFilter: 'all',
      sortBy: 'newest',
      statusOptions: [
        { text: 'All Images', value: 'all' },
        { text: 'Ready', value: 'READY' },
        { text: 'Processing', value: 'PENDING' },
        { text: 'Failed', value: 'FAILED' },
      ],
      sortOptions: [
        { text: 'Newest First', value: 'newest' },
        { text: 'Oldest First', value: 'oldest' },
        { text: 'Name (A-Z)', value: 'name_asc' },
        { text: 'Name (Z-A)', value: 'name_desc' },
        { text: 'Size (Large to Small)', value: 'size_desc' },
        { text: 'Size (Small to Large)', value: 'size_asc' },
      ],
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: 'Danh sách Hình ảnh' }]);
  },
  computed: {
    ...mapGetters('images', ['allImages', 'isLoading']),

    filteredImages() {
      let result = [...this.allImages];

      // Apply status filter
      if (this.statusFilter !== 'all') {
        result = result.filter((image) => image.status === this.statusFilter);
      }

      // Apply search filter
      if (this.search) {
        const searchLower = this.search.toLowerCase();
        result = result.filter(
          (image) =>
            image.name.toLowerCase().includes(searchLower) ||
            image.originalName?.toLowerCase().includes(searchLower),
        );
      }

      // Apply sorting
      switch (this.sortBy) {
        case 'newest':
          result.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
          break;
        case 'oldest':
          result.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
          break;
        case 'name_asc':
          result.sort((a, b) => a.name.localeCompare(b.name));
          break;
        case 'name_desc':
          result.sort((a, b) => b.name.localeCompare(a.name));
          break;
        case 'size_desc':
          result.sort((a, b) => (b.size || 0) - (a.size || 0));
          break;
        case 'size_asc':
          result.sort((a, b) => (a.size || 0) - (b.size || 0));
          break;
      }

      return result;
    },
  },
  methods: {
    ...mapActions('images', ['fetchImages']),

    refreshImages() {
      this.fetchImages();
    },
  },
  created() {
    this.refreshImages();
  },
};
</script>

<style scoped>
.card-title {
  /* padding: 1rem 1rem 0.5rem 1rem; */
}
</style>
